<template>
  <div class="indexPage">
    <div class="list">
      <div class="item" v-if="dataItem != ''">
        <div class="block_one">
          <div class="column flex-rowl">
            <p class="label">创建时间：</p>
            <p class="con">{{ dataItem.order_time }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单状态：</p>
            <p class="con">
              {{
                dataItem.service_order_status == 1
                  ? "待接单"
                  : dataItem.service_order_status == 2
                  ? "已接单"
                  : dataItem.service_order_status == 3
                  ? "取餐中"
                  : dataItem.service_order_status == 4
                  ? "送餐中"
                  : dataItem.service_order_status == 5
                  ? "待自提"
                  : dataItem.service_order_status == 6
                  ? "已送达"
                  : "已完成"
              }}
            </p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单情况：</p>
            <p class="con">
              {{
                dataItem.service_order_property == 1
                  ? "服务订单进行中"
                  : dataItem.service_order_property == 2
                  ? "服务订单取消申请中"
                  : dataItem.service_order_property == 3
                  ? "服务订单已取消"
                  : "服务订单已完成"
              }}
            </p>
          </div>
        </div>

        <div class="block_two">
          <div class="column flex-rowl">
            <p class="label">服务订单号：</p>
            <p class="con">{{ dataItem.service_order_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单号：</p>
            <p class="con">{{ dataItem.order_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送餐位置：</p>
            <p class="con">{{ dataItem.address_detail }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">关联取餐柜：</p>
            <p class="con">{{ dataItem.service_rating }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">用户姓名：</p>
            <p class="con">{{ dataItem.truename }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系电话：</p>
            <p class="con">{{ dataItem.customer_phone }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单内容：</p>
            <p class="con">{{ dataItem.order_content }}</p>
          </div>

          <div class="column column_custom flex-rowr">
            <div
              class="custom_btn"
              :class="{ disabled: dataItem.service_order_status > 2 }"
              @click="handleOrderState('待取餐', dataItem.service_order_status)"
            >
              {{ dataItem.service_order_status == 2 ? "确认取餐" : "已取餐" }}
            </div>
          </div>
        </div>

        <div class="block_three" v-if="dataItem.service_order_status >= 3">
          <div class="column flex-rowl">
            <p class="label">取餐员：</p>
            <p class="con">{{ pickupInfo.pickup_staff_name }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">取餐员工号：</p>
            <p class="con">{{ pickupInfo.pickup_staff_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系方式：</p>
            <p class="con">{{ pickupInfo.pickup_staff_contact }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">取餐时间：</p>
            <p class="con">{{ pickupInfo.pickup_time }}</p>
          </div>
          <div class="column column_custom flex-rowr">
            <div
              class="custom_btn"
              :class="{ disabled: dataItem.service_order_status > 3 }"
              @click="handleOrderState('待送餐', dataItem.service_order_status)"
            >
              {{
                dataItem.service_order_status == 3 ? "进行送餐" : "已进行送餐"
              }}
            </div>
          </div>
        </div>

        <div class="block_three" v-if="dataItem.service_order_status >= 4">
          <div class="column flex-rowl">
            <p class="label">送餐员：</p>
            <p class="con">{{ deliveryInfo.delivery_staff_name }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送餐员工号：</p>
            <p class="con">{{ deliveryInfo.delivery_staff_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系方式：</p>
            <p class="con">{{ deliveryInfo.delivery_staff_contact }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送餐时间：</p>
            <p class="con">{{ deliveryInfo.delivery_assignment_time }}</p>
          </div>
          <!-- 点位类型sitetype=取餐柜、自提点 -->
          <template
            v-if="
              serinfoInfo.dispatch_result == 1 ||
              serinfoInfo.dispatch_result == 2
            "
          >
            <div class="block flex-colc" v-if="serinfoInfo.locker_number">
              <div class="primary-button" @click="handleToast">
                商品放错，重新操作
              </div>
              <div class="primary-button" @click="handleToast">直接送达</div>
              <div class="primary-button" @click="handleToast">订单取消</div>
            </div>
          </template>
          <div
            class="column column_custom flex-colc"
            v-if="dataItem.sitetype == '自提点'"
          >
            <template v-if="dataItem.service_order_status == 4">
              <div
                class="custom_btn"
                @click="
                  handleOrderState('待配送', dataItem.service_order_status, 3)
                "
              >
                <a :href="'tel:' + dataItem.customer_phone">联系用户</a>
              </div>
              <div
                class="custom_btn"
                :class="{ disabled: dataItem.service_order_status > 4 }"
                @click="
                  handleOrderState('待配送', dataItem.service_order_status, 5)
                "
              >
                {{
                  dataItem.service_order_status > 4 &&
                  serinfoInfo.dispatch_result == 5
                    ? "已放至自提点"
                    : "放至自提点"
                }}
              </div>
            </template>
            <template v-else>
              <div class="custom_btn disabled">已放至自提点</div>
              <div class="custom_btn">
                <a :href="'tel:' + dataItem.customer_phone">联系用户</a>
              </div>
            </template>
          </div>
          <div class="column column_custom flex-colc" v-else>
            <template v-if="dataItem.service_order_status == 4">
              <div
                class="custom_btn"
                @click="
                  handleOrderState('待配送', dataItem.service_order_status, 1)
                "
              >
                放入取餐柜（大件）
              </div>
              <div
                class="custom_btn"
                @click="
                  handleOrderState('待配送', dataItem.service_order_status, 2)
                "
              >
                放入取餐柜（小件）
              </div>
              <div
                class="custom_btn"
                @click="
                  handleOrderState('待配送', dataItem.service_order_status, 3)
                "
              >
                <a :href="'tel:' + dataItem.customer_phone">联系用户</a>
              </div>
              <div
                class="custom_btn"
                @click="
                  handleOrderState('待配送', dataItem.service_order_status, 4)
                "
              >
                直接配送
              </div>
            </template>
            <template v-else>
              <div class="custom_btn disabled">
                {{
                  serinfoInfo.dispatch_result == 1
                    ? "已放入取餐柜（大件）"
                    : serinfoInfo.dispatch_result == 2
                    ? "已放入取餐柜（小件）"
                    : "已直接送达"
                }}
              </div>
              <div class="custom_btn">
                <a :href="'tel:' + dataItem.customer_phone">联系用户</a>
              </div>
            </template>
          </div>
        </div>

        <div class="block_three" v-if="dataItem.service_order_status >= 5">
          <div class="column flex-rowl">
            <p class="label">分派员：</p>
            <p class="con">{{ serinfoInfo.dispatch_staff_name }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">分派员工号：</p>
            <p class="con">{{ serinfoInfo.dispatch_staff_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系方式：</p>
            <p class="con">{{ serinfoInfo.dispatch_staff_contact }}</p>
          </div>
          <div class="column dispath_type flex-rowl">
            <p class="label">分派方式：</p>
            <div class="con" v-if="serinfoInfo.dispatch_result">
              <div class="block" v-if="serinfoInfo.dispatch_result == 4">
                <p>直接送达用户</p>
              </div>
              <div class="block" v-if="serinfoInfo.dispatch_result == 5">
                <p>已放至自提点</p>
              </div>
              <div class="block" v-else-if="serinfoInfo.dispatch_result == 1">
                <p>已放入取餐柜</p>
                <p>{{ serinfoInfo.locker_number }}</p>
                <p>{{ serinfoInfo.locker_compartment_number }} 格（大件用）</p>
                <p>{{ serinfoInfo.locker_code }}（开柜码）</p>
              </div>
              <div class="block" v-else-if="serinfoInfo.dispatch_result == 2">
                <p>已放入取餐柜</p>
                <p>{{ serinfoInfo.locker_number }}</p>
                <p>{{ serinfoInfo.locker_compartment_number }} 格（小件用）</p>
                <p>{{ serinfoInfo.locker_code }}（开柜码）</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <van-empty
        description="该订单不存在"
        v-if="!isLoading && dataItem == ''"
      />
    </div>

    <div class="custom_btn" @click="handleReturn">返回</div>

    <van-popup v-model="isShow">
      <div class="popup_pic_container">
        <van-image width="300" :src="popupSrc" />
      </div>
    </van-popup>
  </div>
</template>
  
<script>
import {
  getOrderInfo,
  getToken,
  getTakeMeal,
  getSendMeal,
  getDispatch,
  putBigCabinet,
  putSmallCabinet,
  checkbonxcn,
} from "../../api/api";
export default {
  name: "orderMineDetail",
  data() {
    return {
      isShow: false,
      popupSrc: "",
      isLoading: true,
      userInfo: "", // 用户信息
      dataItem: "", // 订单信息
      pickupInfo: "", // 取餐信息
      deliveryInfo: "", // 送餐信息
      order_id: "", // 订单id
      token: "", // token
      address_detail: "", // 送餐详情
      order_status: "", // 订单状态
      returncheck: 1,
    };
  },
  created() {
    let { id, address_detail, order_status } = this.$route.params;
    this.order_id = id;
    this.address_detail = address_detail;
    this.order_status = order_status;
    this.token = this.$store.state.Authorization;
    this.userInfo = this.$store.state.USERINFO;
    this.getToken();
  },
  methods: {
    // 获取token
    getToken(isSubmit) {
      let { order_status } = this;
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);

          if (isSubmit) {
            this.scoldCheck(res.data.token);
          } else {
            if (order_status <= 4) {
              this.getTakeSendMeal(res.data.token);
            } else {
              this.getOrderInfo(res.data.token);
            }
          }
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },
    // 查看取餐订单
    getOrderInfo(token) {
      let { order_id } = this;
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getOrderInfo({ order_id, token }).then((res) => {
        if (res.error_code == 0) {
          if (Object.values(res.data).length != 0) {
            this.dataItem = res.data;
            this.pickupInfo = res.data.pickup;
            this.deliveryInfo = res.data.delivery;
            this.serinfoInfo =
              Object.values(res.data.serinfo).length != 0
                ? res.data.serinfo
                : "";
          } else {
            this.dataItem = "";
          }
          this.isLoading = false;
          toast.clear();
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
          this.isLoading = false;
          toast.clear();
        }
      });
    },
    handleShowPopup(src) {
      this.isShow = true;
      this.popupSrc = src;
    },

    // 订单取餐-订单送餐-订单配送
    handleOrderState(type, orderState, dispatch_result) {
      let { dataItem } = this;
      if (type == "待取餐") {
        if (dataItem.service_order_status > 2) return;
      } else if (type == "待送餐") {
        if (dataItem.service_order_status > 3) return;
      } else if (type == "待配送") {
        if (dataItem.service_order_status > 4) return;
      }
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          if (type == "待取餐" && orderState == 2) {
            this.getTakeMeal(res.data.token);
          } else if (type == "待送餐" && orderState == 3) {
            this.getSendMeal(res.data.token);
          } else if (type == "待配送" && orderState == 4) {
            this.getDispatch(res.data.token, dispatch_result);
          }
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 提交取餐
    getTakeMeal(token) {
      let { order_id, userInfo } = this;
      const toast = this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
      });
      let params = {
        order_id,
        token,
        pickup_staff_name: userInfo.truename,
        pickup_staff_id: userInfo.accountid,
        pickup_staff_contact: userInfo.mobile,
      };
      getTakeMeal(params).then((res) => {
        if (res.error_code == 0) {
          toast.clear();
          this.$toast.success(res.message);
          setTimeout(() => {
            this.getOrderInfo(token);
          }, 500);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 提交送餐
    getSendMeal(token) {
      let { order_id, userInfo, dataItem } = this;
      const toast = this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
      });
      let params = {
        order_id,
        token,
        delivery_staff_name: userInfo.truename,
        delivery_staff_id: userInfo.accountid,
        delivery_staff_contact: userInfo.mobile,
        current_location: dataItem.address_detail,
      };
      getSendMeal(params).then((res) => {
        if (res.error_code == 0) {
          toast.clear();
          this.$toast.success(res.message);
          setTimeout(() => {
            this.getOrderInfo(token);
          }, 500);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 根据需求调整，取餐-送餐合并
    async getTakeSendMeal(token) {
      let { order_id, userInfo, address_detail } = this;
      const toast = this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
      });
      // 1、取餐
      let takeParams = {
        order_id,
        token,
        pickup_staff_name: userInfo.truename,
        pickup_staff_id: userInfo.accountid,
        pickup_staff_contact: userInfo.mobile,
      };
      let res1 = await getTakeMeal(takeParams);
      if (res1.error_code == 0) {
        // 2、送餐
        let sendParams = {
          order_id,
          token,
          delivery_staff_name: userInfo.truename,
          delivery_staff_id: userInfo.accountid,
          delivery_staff_contact: userInfo.mobile,
          current_location: address_detail,
        };
        let res2 = await getSendMeal(sendParams);
        if (res2.error_code == 0) {
          toast.clear();
          this.getOrderInfo(token);
        } else {
          this.$toast.fail(res2.message || "接口失效，请稍后～");
          setTimeout(() => {
            this.getOrderInfo(token);
          }, 500);
        }
      } else {
        this.$toast.fail(res1.message || "接口失效，请稍后～");
        setTimeout(() => {
          this.getOrderInfo(token);
        }, 500);
      }
    },

    // 提交配送
    getDispatch(token, dispatch_result) {
      let { order_id, userInfo } = this;
      const toast = this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
      });
      let params = {
        order_id,
        token,
        dispatch_staff_id: userInfo.accountid,
        dispatch_result,
      };
      getDispatch(params).then((res) => {
        if (res.error_code == 0) {
          toast.clear();
          this.$toast.success(res.message);
          if (params.dispatch_result == 1) {
            this.putBigCabinet(token);
          } else if (params.dispatch_result == 2) {
            this.putSmallCabinet(token);
          } else {
            setTimeout(() => {
              this.getOrderInfo(token);
            }, 500);
          }
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },
    // 放入大柜
    putBigCabinet(token) {
      let { order_id } = this;
      putBigCabinet({ token, order_id }).then((res) => {
        if (res.error_code != 0) {
          this.$toast.error(res.message || "服务器异常，请稍后");
        } else {
          // setTimeout(() => {
          //   this.getOrderInfo(token);
          // }, 1500);
          this.checkbonxcn(token, order_id);
        }
        // this.getBoxState(token);
      });
    },
    // 放入小柜
    putSmallCabinet(token) {
      let { order_id } = this;
      putSmallCabinet({ token, order_id }).then((res) => {
        if (res.error_code != 0) {
          this.$toast.error(res.message || "服务器异常，请稍后");
        } else {
          // setTimeout(() => {
          //   this.getOrderInfo(token);
          // }, 1500);
          this.checkbonxcn(token, order_id);
        }
        // this.getBoxState(token);
      });
    },
    // 查询开柜是否成功
    checkbonxcn(token, order_id) {
      let params = {
        token,
        order_id,
      };
      checkbonxcn(params).then((res) => {
        if (res.error_code != 0) {
          this.$toast.error(res.message || "服务器异常，请稍后");
        } else {
          this.getOrderInfo(token);
        }
      });
    },

    handleToast() {
      this.$toast("即将开放");
    },

    handleReturn() {
      this.$router.back();
      // this.$router.push({ name: 'orderMineList', params: { id:'2024072615311366851770157' }});
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  padding: 40px 0 300px;
  .list {
    .item {
      width: 660px;
      min-height: 700px;
      background: #ffffff;
      border: 6px solid #e6e6e6;
      border-radius: 40px;
      margin: 0 auto 100px;
      padding: 52px 44px 0;
      box-sizing: border-box;
      font-size: 28px;
      color: #040000;
      .column {
        &.column_custom {
          margin-top: 35px;
          .custom_btn {
            margin: 0;
            &.disabled {
              background: #9e9e9e;
              color: #fff;
            }
            a {
              color: #fff;
            }
          }
          &.flex-colc {
            align-items: flex-end;
            .custom_btn {
              margin-bottom: 25px;
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }
      .block_one {
        font-size: 30px;
        margin-bottom: 65px;
        .column {
          .label {
            width: 140px;
          }
          .con {
            color: #ff0000;
          }
        }
      }
      .block_two {
        margin-bottom: 99px;
      }
      .block_three {
        margin-bottom: 85px;
      }
      .btn {
        margin-bottom: 60px;
      }
      .column {
        align-items: flex-start;
        &:nth-child(2n) {
          margin: 26px 0;
        }
        .label {
          white-space: nowrap;
          width: 190px;
          flex-shrink: 0;
        }
        .con {
          word-wrap: break-word;
          flex-shrink: 0;
          width: 380px;
        }
      }
      .block {
        align-items: flex-end;
        .primary-button {
          height: 60px;
          line-height: 60px;
          margin-bottom: 25px;
          width: 280px;
          box-sizing: border-box;
          font-size: 16px;
          &:first-child {
            margin-top: 40px;
          }
        }
      }
    }
  }
  .popup_pic_container {
    // min-height: 40vh;
  }
}
</style>